import type { EventMatchesToolNamesParams } from '../types';

const eventMatchesToolNames = ({ event, toolNames }: EventMatchesToolNamesParams): boolean =>
    typeof event.toolName === 'string' && toolNames.includes(event.toolName);

export default eventMatchesToolNames;
